import Cookies from "js-cookie";
import { businessLogout } from "../ApiCalls/authentication";
import { loginPathFor } from "./authRedirect";

// L-01 (MA-06): the JWT now lives in an httpOnly cookie the backend sets/clears —
// this is the one HTTP chokepoint most ApiCalls/*.js files go through, so fixing
// cookie transport + CSRF here covers all of them without touching each file.
//
// Cookie split: this app's session cookie is now named `mantis_business_session`
// (not `mantis_session` — that one belongs to mantis-front/Admin) so the two can
// coexist in the same browser without one login overwriting the other's cookie.
// `X-Mantis-App: business` tells the backend which cookie applies to this request —
// both cookies share Domain=mantisapp.co, so the browser sends both once a user is
// logged into both apps, and nothing else on the request says which one this is.
const MUTATING_METHODS = new Set(["POST", "PUT", "PATCH", "DELETE"]);

export async function fetchWrapper(url, options = {}, timeout = 60000) {
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), timeout);
  // B-169: a caller's own signal (the Cierres chat's "Detener respuesta") also cuts the request;
  // the timeout above still applies. No other caller passes one.
  const { signal: externa, ...opciones } = options;
  const abortarPorFuera = () => controller.abort();
  if (externa) {
    if (externa.aborted) controller.abort();
    else externa.addEventListener("abort", abortarPorFuera);
  }
  const method = (opciones.method || "GET").toUpperCase();
  const headers = { ...(opciones.headers || {}) };

  // Clean up any case-insensitive duplicate headers to prevent sending the token twice
  for (const key of Object.keys(headers)) {
    if (key.toLowerCase() === "x-csrf-token") {
      delete headers[key];
    }
  }

  headers["X-Mantis-App"] = "business";

  if (MUTATING_METHODS.has(method)) {
    const csrfToken = Cookies.get("businessCsrfToken");
    if (csrfToken) headers["X-CSRF-Token"] = csrfToken;
  }
  try {
    const response = await fetch(url, {
      ...opciones,
      headers,
      credentials: "include",
      signal: controller.signal,
    });

    if (response.status === 401) {
      handleSessionExpiration();
      return;
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error en fetchWrapper:", error);
    throw error;
  } finally {
    clearTimeout(timeoutId);
    externa?.removeEventListener("abort", abortarPorFuera);
  }
}

// Exported for the one request that reads its answer as it arrives (B-71, `sendCierreDailyReport`).
export function handleSessionExpiration() {
  localStorage.setItem("sessionExpired", true);
  // The login sends the person back to the page the session expired on.
  window.location.href = loginPathFor(window.location);
  businessLogout();
}